export const terminal = state => state.terminal
export const activeComponent = state => state.activeComponent
export const componentsData = state => state.componentsData



// WEBPACK FOOTER //
// ./src/store/getter.js